/* Production responsive and accessibility corrections — 2026-08-06 */
(function(){
  'use strict';
  var doc=document, root=doc.documentElement;
  root.classList.add('js','production-responsive');

  function all(sel,ctx){try{return Array.prototype.slice.call((ctx||doc).querySelectorAll(sel));}catch(e){return[];}}
  function setViewportUnit(){root.style.setProperty('--qa-vh',(window.innerHeight*.01)+'px');}
  setViewportUnit();
  window.addEventListener('resize',function(){setViewportUnit();window.requestAnimationFrame(refreshOpenMenuMetrics);},{passive:true});
  if(window.visualViewport){window.visualViewport.addEventListener('resize',function(){setViewportUnit();window.requestAnimationFrame(refreshOpenMenuMetrics);},{passive:true});}

  var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)');
  function applyMotionPreference(){
    var on=!!(reduced&&reduced.matches);
    root.classList.toggle('reduced-motion',on);
    if(on){
      all('[data-reveal],[data-rv],[data-hero-line],[data-hero-in],[data-split],[data-splitline],.reveal,.fade-up,.reveal-up').forEach(function(el){
        el.style.opacity='1';el.style.visibility='visible';el.style.transform='none';el.style.clipPath='none';
      });
      try{if(window.ScrollTrigger&&typeof window.ScrollTrigger.getAll==='function'){window.ScrollTrigger.getAll().forEach(function(t){try{t.kill(true);}catch(e){}});}}catch(e){}
      try{if(window.lenis&&typeof window.lenis.destroy==='function')window.lenis.destroy();}catch(e){}
    }
  }
  applyMotionPreference();
  if(reduced){if(reduced.addEventListener)reduced.addEventListener('change',applyMotionPreference);else if(reduced.addListener)reduced.addListener(applyMotionPreference);}

  var introSel='.preloader,.preload,#preloader,#pre,[data-preloader]';
  function manageIntro(){
    var home=doc.body&&doc.body.classList.contains('template-index');
    var seen=root.classList.contains('theme-intro-seen');
    if(!home||seen){all(introSel).forEach(function(el){el.hidden=true;el.setAttribute('aria-hidden','true');el.style.display='none';});}
    if(home&&!seen){window.setTimeout(function(){try{if(window.__qaIntroKey)sessionStorage.setItem(window.__qaIntroKey,'1');}catch(e){}},2500);}
  }

  function hideNonHomeAgeGates(){
    if(!doc.body||doc.body.classList.contains('template-index'))return;
    all('[id*="age-gate"],[class*="age-gate"],[data-age-gate]').forEach(function(el){el.hidden=true;el.setAttribute('aria-hidden','true');el.style.display='none';});
    root.className=root.className.replace(/\S*age\S*locked\S*/g,'').trim();
    doc.body.className=doc.body.className.replace(/\S*age\S*open\S*/g,'').trim();
  }

  var menuSel='[data-mobile-menu],.mobile-nav-panel,.mobile-nav,.mobile-menu,.ember-mobile-menu,.md-mobile-menu,.prism-mobile-menu,.volta-mobile-nav';
  var toggleSel='[data-mobile-menu-toggle],[data-menu-toggle],[data-volta-burger],.nav-burger,.burger,.menu-toggle,.md-menu-toggle';
  var lastTrigger=null;

  function toggleForMenu(menu){
    if(!menu)return null;
    var id=menu.id;
    if(id){
      try{var linked=doc.querySelector('[aria-controls="'+CSS.escape(id)+'"]');if(linked)return linked;}catch(e){
        var safe=id.replace(/([\\"'])/g,'\\$1');
        try{var fallback=doc.querySelector('[aria-controls="'+safe+'"]');if(fallback)return fallback;}catch(_e){}
      }
    }
    if(menu.id==='mobileNav')return doc.getElementById('burger');
    if(menu.id==='prismMobileMenu')return doc.getElementById('burger');
    return null;
  }
  function syncToggleA11y(t){
    if(!t)return;
    var open=t.getAttribute('aria-expanded')==='true';
    t.setAttribute('aria-label',open?'Close navigation menu':'Open navigation menu');
    var sr=t.querySelector('.visually-hidden');
    if(sr)sr.textContent=open?'Close menu':'Open menu';
  }
  function sizeScrollableMenu(menu){
    if(!menu)return;
    menu.setAttribute('data-qa-menu-scroll','true');
    var rect;
    try{rect=menu.getBoundingClientRect();}catch(e){rect={top:0};}
    var top=Math.max(0,Math.min(window.innerHeight||0,Math.round(rect.top||0)));
    var available=Math.max(180,(window.innerHeight||document.documentElement.clientHeight||640)-top-8);
    menu.style.setProperty('--qa-menu-available-height',available+'px');
  }
  function refreshOpenMenuMetrics(){
    all(menuSel).forEach(function(menu){if(menuIsOpen(menu))sizeScrollableMenu(menu);});
  }
  function menuIsOpen(menu){
    if(!menu||menu.hidden)return false;
    if(menu.getAttribute('aria-hidden')==='false')return true;
    if(/(^|\s)(open|is-open|active|on|show|shown)(\s|$)/.test(menu.className||''))return true;
    var id=menu.id;
    if(id){var t=doc.querySelector('[aria-controls="'+CSS.escape(id)+'"]');if(t&&t.getAttribute('aria-expanded')==='true')return true;}
    return false;
  }
  function syncMenuLock(){
    var openMenu=all(menuSel).find(menuIsOpen);
    doc.body&&doc.body.classList.toggle('theme-menu-open',!!openMenu);
    all(toggleSel).forEach(syncToggleA11y);
    if(openMenu){
      openMenu.setAttribute('role',openMenu.getAttribute('role')||'dialog');
      openMenu.setAttribute('aria-modal','true');
      sizeScrollableMenu(openMenu);
      var linkedToggle=toggleForMenu(openMenu);
      if(linkedToggle){linkedToggle.setAttribute('aria-expanded','true');syncToggleA11y(linkedToggle);}
    }
  }
  function closeMenus(restore){
    all(menuSel).forEach(function(menu){
      menu.classList.remove('open','is-open','active','on','show','shown');
      menu.setAttribute('aria-hidden','true');
      if(menu.hasAttribute('data-mobile-nav')||menu.hasAttribute('data-mobile-menu'))menu.hidden=true;
    });
    all(toggleSel).forEach(function(t){t.classList.remove('open','is-open','active');t.setAttribute('aria-expanded','false');syncToggleA11y(t);});
    if(doc.body)doc.body.classList.remove('theme-menu-open');
    if(restore&&lastTrigger&&typeof lastTrigger.focus==='function')try{lastTrigger.focus();}catch(e){}
  }
  function initMenus(ctx){
    all(toggleSel,ctx).forEach(function(t){
      if(!t.hasAttribute('aria-expanded'))t.setAttribute('aria-expanded','false');
      if(!t.hasAttribute('aria-label'))t.setAttribute('aria-label','Open navigation menu');
      syncToggleA11y(t);
      if(!t.dataset.qaMenuObserved){
        t.dataset.qaMenuObserved='1';
        t.addEventListener('click',function(){lastTrigger=t;window.requestAnimationFrame(syncMenuLock);});
        new MutationObserver(function(){syncToggleA11y(t);window.requestAnimationFrame(syncMenuLock);}).observe(t,{attributes:true,attributeFilter:['aria-expanded','class']});
      }
    });
    all(menuSel,ctx).forEach(function(menu){
      if(menu.dataset.qaMenuObserved)return;
      menu.dataset.qaMenuObserved='1';
      new MutationObserver(syncMenuLock).observe(menu,{attributes:true,attributeFilter:['class','hidden','aria-hidden']});
      menu.addEventListener('click',function(e){
        if(e.target===menu||e.target.closest('a'))window.setTimeout(function(){closeMenus(false);},0);
      });
    });
    /* Remove only true duplicate controls targeting the same drawer. */
    var groups={};
    all(toggleSel).forEach(function(t){var k=t.getAttribute('aria-controls');if(!k)return;(groups[k]||(groups[k]=[])).push(t);});
    Object.keys(groups).forEach(function(k){groups[k].slice(1).forEach(function(t){t.hidden=true;t.setAttribute('aria-hidden','true');});});
    syncMenuLock();
  }

  function labelControls(ctx){
    all('button,a,[role="button"]',ctx).forEach(function(el){
      if(el.getAttribute('aria-label')||el.textContent.trim())return;
      var title=el.getAttribute('title');
      var cls=el.className&&String(el.className);
      if(title)el.setAttribute('aria-label',title);
      else if(/search/i.test(cls))el.setAttribute('aria-label','Search');
      else if(/account|user/i.test(cls))el.setAttribute('aria-label','Account');
      else if(/cart|bag/i.test(cls))el.setAttribute('aria-label','Cart');
      else if(/close/i.test(cls))el.setAttribute('aria-label','Close');
    });
  }

  function stabilizeMedia(ctx){
    all('img',ctx).forEach(function(img){
      function apply(){if(!img.hasAttribute('width')&&img.naturalWidth)img.setAttribute('width',img.naturalWidth);if(!img.hasAttribute('height')&&img.naturalHeight)img.setAttribute('height',img.naturalHeight);}
      if(img.complete)apply();else img.addEventListener('load',apply,{once:true});
    });
  }

  function refreshAnimations(){
    window.requestAnimationFrame(function(){
      try{if(window.ScrollTrigger&&typeof window.ScrollTrigger.refresh==='function')window.ScrollTrigger.refresh(true);}catch(e){}
    });
  }

  function init(ctx){manageIntro();hideNonHomeAgeGates();initMenus(ctx||doc);labelControls(ctx||doc);stabilizeMedia(ctx||doc);applyMotionPreference();refreshAnimations();}

  doc.addEventListener('keydown',function(e){
    if(e.key==='Escape'){closeMenus(true);return;}
    if(e.key==='Tab'){
      var menu=all(menuSel).find(menuIsOpen);if(!menu)return;
      var focusables=all('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])',menu).filter(function(x){return !x.hidden&&x.offsetParent!==null;});
      if(!focusables.length)return;
      var first=focusables[0],last=focusables[focusables.length-1];
      if(e.shiftKey&&doc.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&doc.activeElement===last){e.preventDefault();first.focus();}
    }
  });

  if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',function(){init(doc);},{once:true});else init(doc);
  window.addEventListener('load',refreshAnimations,{once:true});
  doc.addEventListener('shopify:section:load',function(e){init(e.target);});
  doc.addEventListener('shopify:section:reorder',refreshAnimations);
  doc.addEventListener('shopify:block:select',refreshAnimations);
})();
